import React from 'react';
import {
  Modal,
  Button,
  Typography,
  List,
  Alert
} from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const { Text } = Typography;

// Double-booking confirmation modal
export const DoubleBookConfirmModal = ({
  visible,
  onCancel,
  onConfirm,
  pendingSlot
}) => (
  <Modal
    title={
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#fa8c16' }}>
        <ExclamationCircleOutlined />
        <span>Confirm Double-Booking</span>
      </div>
    }
    open={visible}
    onCancel={onCancel}
    footer={[
      <Button key="cancel" onClick={onCancel}>
        Cancel
      </Button>,
      <Button 
        key="confirm" 
        type="primary" 
        danger
        onClick={onConfirm}
      >
        Confirm Double-Book
      </Button>
    ]}
  >
    <Alert
      type="warning"
      showIcon
      style={{ marginBottom: '16px' }}
      message="This time slot is already booked"
      description="You are about to create a double-booking. This will schedule two appointments at the same time."
    />
    
    {pendingSlot?.conflictingBookings?.length > 0 && (
      <div>
        <Text strong style={{ display: 'block', marginBottom: '8px' }}>
          Existing booking(s) at this time:
        </Text>
        <List
          size="small"
          bordered
          dataSource={pendingSlot.conflictingBookings}
          renderItem={(booking) => (
            <List.Item>
              <div>
                <Text strong>{booking.name || 'Unknown'}</Text>
                <br />
                <Text type="secondary" style={{ fontSize: '12px' }}>
                  {booking.confirmationCode} • {booking.bookingTime} • {booking.status}
                </Text>
                {booking.email && (
                  <>
                    <br />
                    <Text type="secondary" style={{ fontSize: '12px' }}>
                      {booking.email}
                    </Text>
                  </>
                )}
              </div>
            </List.Item>
          )}
        />
      </div>
    )}
  </Modal>
);

// Blocked date confirmation modal
export const BlockedDateConfirmModal = ({
  visible,
  onCancel,
  onConfirm,
  pendingDate
}) => (
  <Modal
    title={
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#cf1322' }}>
        <ExclamationCircleOutlined />
        <span>Confirm Booking on Blocked Date</span>
      </div>
    }
    open={visible}
    onCancel={onCancel}
    footer={[
      <Button key="cancel" onClick={onCancel}>
        Cancel
      </Button>,
      <Button 
        key="confirm" 
        type="primary" 
        danger
        onClick={onConfirm}
      >
        Proceed Anyway
      </Button>
    ]}
  >
    <Alert
      type="error"
      showIcon
      style={{ marginBottom: '16px' }}
      message="This date has been blocked"
      description={
        <div>
          <p style={{ marginBottom: '8px' }}>
            The date <strong>{pendingDate?.format('MMMM D, YYYY')}</strong> has been blocked for this event type.
          </p>
          <p style={{ marginBottom: 0 }}>
            As an admin, you can still create a booking on this date if necessary. This action will be logged.
          </p>
        </div>
      }
    />
  </Modal>
);
